export default {
  prefix: 'linkchat-pro-',
};
